interface WatermarkOption {
    width: number;
    height: number;
    fontSize?: string
}
let setWatermark = (str: string, element: any, option: WatermarkOption ): any => {
    if(!element || !element.children) return;
    let currCan = null as HTMLElement;
    Array.prototype.slice.call(element.children).forEach((item: any) => {
        if(item.id === "__app_global_water_mark") currCan = item;
    })
    if(currCan !== null) {
        if(currCan.style.width !==  `${element.offsetWidth}px`){
            currCan.style.width =  `${element.offsetWidth}px`;
            currCan.style.height =  `${element.offsetHeight}px`;
        }
        return;
       
    }
    // 创建一个画布
    let can = document.createElement('canvas');
    // 设置画布的长宽
    can.width = option.width;
    can.height = option.height;

    let cans = can.getContext('2d');
    // 旋转角度
    cans.rotate(-30 * Math.PI / 180);
    cans.font = option.fontSize ? `${option.fontSize} Arial` : '18px Arial';
    // 设置填充绘画的颜色、渐变或者模式
    cans.fillStyle = 'rgba(200, 200, 200, 0.2)';
    // 设置文本内容的当前对齐方式
    cans.textAlign = 'left';
    // 设置在绘制文本时使用的当前文本基线
    cans.textBaseline = 'middle';
    // 在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
    cans.fillText(str, 0 , option.height / 2);
    let div = document.createElement('div');
    div.id = "__app_global_water_mark"
    div.style.pointerEvents = 'none';
    div.style.top = "0";
    div.style.right = "0";
    div.style.position = 'absolute';
    div.style.zIndex = '100000';
    div.style.width = element.offsetWidth.toString() + "px";
    div.style.height = element.offsetHeight.toString() + "px";
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
    element.style.position = "relative"
    element.appendChild(div);
}

export default setWatermark;


// WEBPACK FOOTER //
// ./src/layouts/WaterMark.tsx